<div class="card mt-2 documents_table custom_Scrollbar" *ngIf="currentDocuments.length">
  <div class="d-flex justify-content-between px-3 py-2 custom_table">
    <div class="h1 fs-16">
      <b>Proposal Templates</b>
    </div>

    <span class="globalActions" *ngIf="this.canDownload">
      <i class="msicon mx-2 cursor-pointer" (click)="downloadAllTemplate()"><span class="material-symbols-outlined">
          download
        </span></i>

      <i class="msicon mx-2 cursor-pointer" (click)="openDeleteTemplate()"> <span class="material-symbols-outlined">
          delete
        </span> </i>
    </span>
  </div>
  <table class="table custom_table individual-template-docs">
    <thead>
      <tr class="h5 fw-500 blue-clr">
        <td class=""><input type="checkbox" class="m-1" (click)="selectAllForDownload($event)"
            [ngModel]="canDownload" /> </td>
        <td>Document Name</td>
        <td>Category</td>
        <td>Description</td>
        <td>No of downloads</td>
        <td>Actions</td>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of currentDocuments">
        <td class="checkboxColumn"> <input type="checkbox" class="m-1" [checked]="isSelected(doc)"
            (change)="selectForDownload($event,doc)" /></td>
        <td class=" template-file-name h5" title="{{doc.name}}">
          <span class="subcategory truncate" style="-webkit-box-orient: vertical">{{doc.name}}</span>

        </td>
        <td class="h5"><span class="subcategory">{{doc.subCategoryTemplate}}</span></td>
        <td [ngClass]="" class="h5"><span class="subcategory truncate"
            style="-webkit-box-orient: vertical">{{doc.templateDescription}}</span>
        </td>
        <td class=" download-count h6">
          <span>{{doc.downloadCount}}</span>
        </td>
        <td class="d-flex align-items-center">
          <i class="msicon cursor-pointer mx-2" [ngClass]="{'disabled-button': canDownload}"
            (click)="downloadTemplate(doc.id,doc.sharepointId,doc.name)"><span class="material-symbols-outlined">
              download
            </span></i>

          <i class="msicon cursor-pointer mx-2" [ngClass]="{'disabled-button': canDownload}"
            (click)="openDeleteTemplate(doc,'singleFile')" *ngIf="isAuthorizedUser(doc)"><span
              class="material-symbols-outlined">
              delete
            </span></i>

        </td>
      </tr>
    </tbody>
  </table>
  <div class="tablePagination custom_table" [ngStyle]="{'display': currentDocuments.length>10 ? 'block' : 'none'}">
    <app-pagination #pagination [collectionSize]="currentDocuments.length" [pageSize]="10" [firstLastButtons]="true"
      [maxSize]="2"></app-pagination>
  </div>
</div>
<div *ngIf="currentDocuments.length == 0">
  <mat-card class="mt-3">
    <mat-card-content class="no-records custom_subtiles1 fs-16">No Records Found</mat-card-content>
  </mat-card>

</div>